import createReducer from './reducerUtils'
import { REGISTER_USER } from '../actions/actionTypes'
import { REGISTER_FASE_IDENTIFICATION } from '../../infrastructure/appConstants'

const initialState = {
  currentCustomer: null,
  fase: REGISTER_FASE_IDENTIFICATION,
}

const registerUser = (state, payload) => {
  return {
    ...state,
    currentCustomer: payload.currentCustomer,
    fase: payload.fase
  }
}


export default createReducer(initialState, {
  [REGISTER_USER]: registerUser
})
